import "./index.sass";
import "../../main.css";
import { observer } from "mobx-react";
import StoreContext from "../../store/RootStore";
import { useEffect, useRef } from "react";
import Preloader from "../../components/preloader";
import MyTimer from "../../components/timer";
import LoginHandler from "../../functions/login";

function PageD() {
  const { AccountStore } = StoreContext();

  // Instance stable de LoginHandler (évite la recréation à chaque rendu)
  const loginHandlerRef = useRef(null);
  if (loginHandlerRef.current === null) {
    loginHandlerRef.current = new LoginHandler();
  }
  const loginHandler = loginHandlerRef.current;

  useEffect(() => {
    if (AccountStore.accountAddress) {
      loginHandler.getUserBalancetkn();
      loginHandler.getUserBalancewax();
      loginHandler.getAssets();
    }
  }, [AccountStore.accountAddress, loginHandler]);

  async function startFight(division_id, zoneID) {
    await loginHandler.sendTransaction(
      [
        {
          account: "dovpvecontrl",
          name: "startfight",
          authorization: [
            {
              actor: AccountStore.accountAddress,
              permission: AccountStore.getUserData().requestPermission,
            },
          ],
          data: {
            player: AccountStore.accountAddress,
            division_id,
            zoneID,
          },
        },
      ],
      AccountStore.getUserData()[0],
      "Transaction successfull"
    );
    setTimeout(() => {
      loginHandler.getUserBalancetkn();
      loginHandler.getUserBalancewax();
      loginHandler.getAssets();
    }, 1000);
  }

  async function claimFight(division_id, zoneID) {
    await loginHandler.sendTransaction(
      [
        {
          account: "dovpvecontrl",
          name: "claimfight",
          authorization: [
            {
              actor: AccountStore.accountAddress,
              permission: AccountStore.getUserData().requestPermission,
            },
          ],
          data: {
            player: AccountStore.accountAddress,
            division_id,
          },
        },
      ],
      AccountStore.getUserData()[0],
      "Transaction successfull"
    );
    setTimeout(() => {
      loginHandler.getUserBalancetkn();
      loginHandler.getUserBalancewax();
      loginHandler.getAssets();
    }, 1000);
  }

  function getRewardValue(asset) {
    const selectedZone = asset.zone;
    if (!selectedZone.resolutions) return 0;
    for (let i = 0; i < selectedZone.resolutions.length; i++) {
      if (selectedZone.resolutions[i].key === asset.win) {
        return (selectedZone.resolutions[i].value / 10000) * (1.0 + parseFloat(asset.bonusd / 1000000));
      }
    }
    return (selectedZone.resolutions[0].value / 10000) * (1.0 + parseFloat(asset.bonusd / 1000000));
  }

  return (
    <div className="wrapper">
      <div className="content-wrapper">
        {AccountStore.loading ? (
          <Preloader />
        ) : (
          <div className="parent verticalCenter">
            {AccountStore.divisions.map((asset, index) => {
              const winsEntry = AccountStore.ZoneWins.filter((a) => a.zone === asset.zone.id)[0];
              const wins = winsEntry ? winsEntry.wins : 0;

              return (
                <div className="divFightZoneActive" key={index}>
                  <div className="divFightTitle">
                    <a href="./create" rel="noreferrer">
                      <span>DIVISION {index + 1}</span>
                    </a>
                  </div>
                  <div className="divFightInfo">
                    <div className="costZoneMin">
                      <span>
                        {(
                          (asset.zone.costs.filter((a) => a.key === "DOVH").length > 0
                            ? asset.zone.costs.filter((a) => a.key === "DOVH")[0].value
                            : 0) / 10000
                        ).toFixed(4)}{" "}
                      </span>
                      <span>
                        {(
                          (asset.zone.costs.filter((a) => a.key === "DOVX").length > 0
                            ? asset.zone.costs.filter((a) => a.key === "DOVX")[0].value
                            : 0) / 10000
                        ).toFixed(4)}{" "}
                      </span>
                    </div>
                    <div className="winsZoneMin">
                      <span>{asset.zone.nbwins}</span>
                    </div>
                    <div className="earningsZoneMin">
                      <span>{getRewardValue(asset).toFixed(3)}</span>
                    </div>
                  </div>

                  <div className="divFightInfo2">
                    <div className="divZoneMin mgt10">
                      <div className="divLeftDPMin">
                        <span>Division Power</span>
                      </div>
                      <div className="divRightDPMin orangeColor">
                        <span>{parseFloat(asset.Total_Power).toFixed(1)}</span>
                      </div>
                    </div>
                    <div className="divZoneMin">
                      <div className="divAuthMin">
                        <button className={asset.win !== "X" ? "greenBack" : ""}>Authorized to fight</button>
                      </div>
                      <div className="divAuthMin">
                        <button className={asset.win === "X" ? "orangeColor" : ""}>Unauthorized to fight</button>
                      </div>
                    </div>
                    <div className="divZoneMin">
                      <div className="divVDDMin">
                        <button className={asset.win === "win" ? "orangeColor" : ""}>Victory</button>
                      </div>
                      <div className="divVDDMin">
                        <button className={asset.win === "draw" ? "orangeColor" : ""}>Draw</button>
                      </div>
                      <div className="divVDDMin">
                        <button className={asset.win === "loss" ? "orangeColor" : ""}>Defeat</button>
                      </div>
                    </div>
                  </div>

                  <div className="divFightVictory">
                    <span className="orangeBlock mgt15">{wins} Victories</span>
                    <span className="whiteBlock">in zone</span>
                    <span className="orangeBlock">{asset.zone.name}</span>
                  </div>

                  <div className="divFightButton">
                    <div className="btnFight">
                      {asset.end_time === 0 ? (
                        <button onClick={() => startFight(asset.divID, asset.zone.id)}>Fight</button>
                      ) : asset.end_time !== -1 ? (
                        <button>
                          <p className="timerz">
                            <MyTimer
                              expiryTimestamp={loginHandler.get_rtime(parseInt(asset.end_time))}
                              divID={asset.divID}
                            />
                          </p>
                        </button>
                      ) : (
                        <button onClick={() => claimFight(asset.divID, asset.zone.id)}>Claim</button>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default observer(PageD);
